import React, { Component } from "react";
import { FormGroup, ControlLabel, FormControl, Row } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

function FieldGroup({ label, ...props }) {
  return (
    props.componentClass!= 'select'?
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      {props.tooltip?<OverlayTrigger placement="right" overlay={<Tooltip>{props.tooltip}</Tooltip>}><FormControl {...props} /></OverlayTrigger>:<FormControl {...props} />}
    </FormGroup>:
    <FormGroup>
    <ControlLabel>{label}</ControlLabel>
      <FormControl {...props}>
      {
        props.options.map((option, index) => {
            return (<option key={index} value={option.value} selected={props.selected == option.value}>{option.value}</option>)
        })
      }
    </FormControl>
  </FormGroup>
  );
}

export class FormInputs extends Component {
  render() {
    var row = [];
    for (var i = 0; i < this.props.ncols.length; i++) {
        row.push(
          <div key={i} className={this.props.ncols[i]}>
            <FieldGroup {...this.props.properties[i]} inputRef={this.props.inputRef} onChange={this.props.onChange} />
          </div>
        );
    }
    return <Row>{row}</Row>;
  }
}

export default FormInputs;
